import { apiErrorHandler } from '@/helpers/errorHandlers'

import API from '../client'

const searchCities = async (city) => {
  const route = `api/cities?searchText=${city}`
  return API.get(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

export { searchCities }
